import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import type { TldrResult } from "./commandTypes";
import "./tldrReading.css";

/** A reversible reading projection for every host. The underlying page remains mounted and keeps its state. */
export function TldrReading({ result, onRestore }: { result: TldrResult; onRestore: () => void }) {
  const { t } = useTranslation();
  const [host, setHost] = useState<HTMLElement | null>(null);
  useEffect(() => {
    const main = document.querySelector<HTMLElement>("main");
    if (!main) return;
    main.classList.add("docit-tldr-reading");
    setHost(main);
    return () => {
      main.classList.remove("docit-tldr-reading");
    };
  }, []);
  return host
    ? createPortal(
        <article data-tldr-reading="true" className="tldr-page" aria-label={t("Summarized page")}>
          <header>
            <h1>{t("TL;DR")}</h1>
            <button type="button" onClick={onRestore}>
              {t("Show full page")}
            </button>
          </header>
          <p className="tldr-page-lead" dir="auto">
            {result.tldr}
          </p>
          <div className="tldr-page-insights">
            {result.insights.map((line, i) => (
              <section key={i}>
                <span aria-hidden>{i + 1}</span>
                <p dir="auto">{line}</p>
              </section>
            ))}
          </div>
          {!!result.basis.length && (
            <p className="tldr-page-basis">
              {t("Based on: {{basis}}", { basis: result.basis.join(", ") })}
            </p>
          )}
          <p className="tldr-page-basis">
            {t(
              "This reading summarizes the available screen context. Open the full page for all details and controls.",
            )}
          </p>
          <button type="button" onClick={onRestore}>
            {t("Show full page")}
          </button>
        </article>,
        host,
      )
    : null;
}
